export const getCartItem = (state, id) => {
    const list = state.cart.list;

    return typeof list[id] != 'undefined' && list[id] ? list[id] : null;
};
export const getFinalBuyableLink = (item) => {
    const {
        ID,
        BuyableLink,
        IsCustomTag,
    } = item;

    const finalBuyableLink = IsCustomTag === true ? `${BuyableLink}?cartItem=${ID}` : BuyableLink;

    return finalBuyableLink;
};
/**
 * Get the list of cart items
 * Assuming that we only have 2 levels
 *
 * @param cartList
 * @returns {any[]}
 */
export const getCartList = (cartList) => {

    const cartSortFunction = (a, b) => {
        const dateA = a.Created || '';
        const dateB = b.Created || '';

        return (dateA > dateB) ? 1 : ((dateB > dateA) ? -1 : 0);
    };

    let newCartList = JSON.parse(JSON.stringify(cartList));

    // Put all children to its respective parent
    let childrenList = Object.values(newCartList).filter(item => item.ParentItemID > 0);
    childrenList.forEach(item => {
        const { ParentItemID } = item;

        if (typeof (newCartList[ParentItemID]) != 'undefined') {
            if (typeof (newCartList[ParentItemID].Children) == 'undefined') {
                newCartList[ParentItemID].Children = [];
            }

            newCartList[ParentItemID].Children.push(item);
        }

        return item;
    });

    // Now get only the parent list
    let parentList = Object.values(newCartList).filter(item => item.ParentItemID <= 0);

    // Sort children in parent list
    parentList = parentList.map(item => {
        if (typeof (parentList.Children) != 'undefined') {
            parentList.Children.sort(cartSortFunction);
        }

        return item;
    });


    // Sort parent list
    parentList.sort(cartSortFunction);
    return parentList;
};
export const getCurrentCartNotes = (store) => {
    const { list, userInput, selectedCartNoteId } = store.cart;

    if (typeof (userInput[selectedCartNoteId]) != 'undefined') {
        return userInput[selectedCartNoteId].__Notes;
    }

    if (typeof (list[selectedCartNoteId]) != 'undefined') {
        return list[selectedCartNoteId].Notes;
    }

    return '';
};
/**
 * A helper function to decide whether cart item displays tax or not
 *
 * @param TotalPriceWithTax
 * @param TotalPriceWithoutTax
 * @returns {*}
 */
export const getCartItemTotalPrice = (TotalPriceWithTax, TotalPriceWithoutTax) => {
    const showTax = window.showTaxInclusive || 0;

    if (showTax) {
        return TotalPriceWithTax;
    }

    return TotalPriceWithoutTax;
};
